
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/google-campaign-manager",
      function () {
        return require("private-next-pages/destinations/google-campaign-manager.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/google-campaign-manager"])
      });
    }
  